const SITE_URL = 'https://estumejoropcion.com';
const DEFAULT_OG_IMAGE = `${SITE_URL}/og-image.png`;

const DEFAULT_HOME_META = {
  title: 'Es tu mejor opción — Digital services blog and store for Latin America',
  description: 'Bilingual blog, SEO-focused content, and digital services: domain registration, hosting, VPS, and simple or custom websites. Serving Latin America with presence in Paraguay and Bolivia.',
  image: DEFAULT_OG_IMAGE,
  url: `${SITE_URL}/`,
  type: 'website'
};

function upsertMeta(selector, attr, attrValue, content) {
  if (!content) return;
  let el = document.querySelector(selector);
  if (!el) {
    el = document.createElement('meta');
    el.setAttribute(attr, attrValue);
    document.head.appendChild(el);
  }
  el.setAttribute('content', content);
}

function upsertCanonical(url) {
  if (!url) return;
  let el = document.querySelector('link[rel="canonical"]');
  if (!el) {
    el = document.createElement('link');
    el.setAttribute('rel', 'canonical');
    document.head.appendChild(el);
  }
  el.setAttribute('href', url);
}

export function setPageOgMeta({ title, description, image, url, type = 'website' }) {
  if (title) {
    document.title = title;
    upsertMeta('meta[property="og:title"]', 'property', 'og:title', title);
    upsertMeta('meta[property="twitter:title"]', 'property', 'twitter:title', title);
  }
  if (description) {
    upsertMeta('meta[name="description"]', 'name', 'description', description);
    upsertMeta('meta[property="og:description"]', 'property', 'og:description', description);
    upsertMeta('meta[property="twitter:description"]', 'property', 'twitter:description', description);
  }
  if (url) {
    upsertMeta('meta[property="og:url"]', 'property', 'og:url', url);
    upsertMeta('meta[property="twitter:url"]', 'property', 'twitter:url', url);
    upsertCanonical(url);
  }
  if (type) {
    upsertMeta('meta[property="og:type"]', 'property', 'og:type', type);
  }
  if (image) {
    upsertMeta('meta[property="og:image"]', 'property', 'og:image', image);
    upsertMeta('meta[property="twitter:image"]', 'property', 'twitter:image', image);
    upsertMeta('meta[property="twitter:card"]', 'property', 'twitter:card', 'summary_large_image');
  }
}

export function resetToHomeMeta() {
  setPageOgMeta(DEFAULT_HOME_META);
}

export { DEFAULT_HOME_META, DEFAULT_OG_IMAGE, SITE_URL };
